module.exports = __webpack_public_path__ + "img/folder-green.3bc0a33b.svg";